import { Button } from "../../../core/components/button.js";
import { DirectionsCommonProps } from "../../directions/directions.js";
import { ToggleButton } from "../../../core/components/toggleButton.js";
import { RouteObject } from "../../geomapUtil.js";
import React from "react";
export class DirectionsDisplay extends React.Component<DirectionsDisplayProps, any>{
    render() {
        return (
            <div>
                <div style={{ position: "absolute", top: "60px", right: "12px", display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                    <Button handleClick={this.props.newRoute} buttonStyle={{ marginRight: "2px", borderRadius: "var(--border-radius)" }} title={this.props.translations["GeoMap.AddNewContainer"]} iconName={"plus"} />
                    <Button handleClick={this.props.newContainerView} buttonStyle={{ marginRight: "2px", borderRadius: "var(--border-radius)" }} title={this.props.translations["Einsatz.Container"]} iconName={"table"} />
                    <Button handleClick={this.props.newActiveResourceAssignmentsView} buttonStyle={{ marginRight: "2px", borderRadius: "var(--border-radius)" }} title={this.props.translations["GeoMap.ActiveResourceAssignments"]} iconName={"compass"} />
                    <Button handleClick={this.props.openResourceFilter} buttonStyle={{ display: this.props.showFilter ? "inline-flex" : "none", borderRadius: "var(--border-radius)" }} title={this.props.translations["GeoMap.AssignmentFilter"]} iconName={"filter"} />
                    <ToggleButton handleToggle={this.props.toggleLiveLocation} buttonStyle={{ marginRight: "2px", borderRadius: "var(--border-radius)" }} title={this.props.translations["GeoMap.LiveLocation"]} iconName={"car"} />
                </div>
                <div id="geomap__directions" ref={(r) => { this.props.setDirectionsDiv(r); }}>
                    <div style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "100%", width: "400px", padding: "5px" }}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

interface DirectionsDisplayProps extends DirectionsCommonProps {
    showFilter: boolean;
    newRoute(e?: React.MouseEvent<HTMLDivElement>, setState?: boolean): Array<RouteObject> | void;
    newContainerView(e?: React.MouseEvent<HTMLDivElement>, start?: Date, end?: Date): void;
    newActiveResourceAssignmentsView(e?: React.MouseEvent<HTMLDivElement>, timestamp?: Date): void;
    openResourceFilter(): void;
    setDirectionsDiv(elem: HTMLDivElement): void;
    toggleLiveLocation(toggleState: boolean): void;
}